(function () {
  var root = document.querySelector("[data-collection]");
  if (!root || root.dataset.collectionBound) return;
  root.dataset.collectionBound = "1";

  var grid = root.querySelector("[data-collection-grid]");
  var paginationNav = root.querySelector("[data-collection-pagination]");
  var countEl = root.querySelector("[data-collection-count]");
  var sectionId = root.getAttribute("data-section-id");
  var collectionUrl = root.getAttribute("data-collection-url");
  var currentPage = parseInt(root.getAttribute("data-current-page"), 10) || 1;
  var totalPages = parseInt(root.getAttribute("data-total-pages"), 10) || 1;
  var totalItems = parseInt(root.getAttribute("data-total-items"), 10) || 0;
  var currentSort = root.getAttribute("data-current-sort") || "manual";
  var loading = false;
  var body = document.body;

  var sortRoot = root.querySelector("[data-collection-sort]");
  var sortToggle = sortRoot && sortRoot.querySelector("[data-sort-toggle]");
  var sortDropdown = sortRoot && sortRoot.querySelector("[data-sort-dropdown]");
  var sortOverlay = root.querySelector("[data-sort-overlay]");
  var sortLabel = sortRoot && sortRoot.querySelector("[data-sort-label]");
  var sortOptions = sortRoot ? sortRoot.querySelectorAll("[data-sort-option]") : [];
  var sortClosers = root.querySelectorAll("[data-sort-close]");

  function isSortOpen() {
    return sortDropdown && sortDropdown.classList.contains("is-open");
  }

  function openSort() {
    if (!sortDropdown || !sortToggle) return;
    sortDropdown.classList.add("is-open");
    sortDropdown.setAttribute("aria-hidden", "false");
    sortToggle.setAttribute("aria-expanded", "true");
    if (sortOverlay) {
      sortOverlay.classList.add("is-open");
      sortOverlay.setAttribute("aria-hidden", "false");
    }
    body.classList.add("is-sort-open");
  }

  function closeSort() {
    if (!sortDropdown || !sortToggle) return;
    sortDropdown.classList.remove("is-open");
    sortDropdown.setAttribute("aria-hidden", "true");
    sortToggle.setAttribute("aria-expanded", "false");
    if (sortOverlay) {
      sortOverlay.classList.remove("is-open");
      sortOverlay.setAttribute("aria-hidden", "true");
    }
    body.classList.remove("is-sort-open");
  }

  if (sortToggle && sortDropdown) {
    sortToggle.addEventListener("click", function (event) {
      event.stopPropagation();
      if (isSortOpen()) closeSort();
      else openSort();
    });

    sortClosers.forEach(function (el) {
      el.addEventListener("click", closeSort);
    });

    if (sortOverlay) {
      sortOverlay.addEventListener("click", closeSort);
    }

    sortOptions.forEach(function (option) {
      option.addEventListener("click", function () {
        var value = option.getAttribute("data-sort-value");
        var label = option.getAttribute("data-sort-label") || option.textContent.trim();

        sortOptions.forEach(function (item) {
          var active = item === option;
          item.classList.toggle("is-active", active);
          item.setAttribute("aria-selected", active ? "true" : "false");
        });

        if (sortLabel) sortLabel.textContent = label;
        if (sortRoot) sortRoot.setAttribute("data-sort-value", value || "");
        closeSort();

        currentSort = value || "manual";
        reloadCollection(1);
      });
    });

    document.addEventListener("click", function (event) {
      if (!isSortOpen()) return;
      if (window.matchMedia("(max-width: 768px)").matches) return;
      if (sortRoot.contains(event.target)) return;
      closeSort();
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && isSortOpen()) closeSort();
    });
  }

  function buildSectionUrl(page) {
    return (
      collectionUrl +
      "?page=" +
      page +
      "&sort_by=" +
      encodeURIComponent(currentSort) +
      "&section_id=" +
      sectionId
    );
  }

  function buildPublicUrl(page) {
    return (
      collectionUrl +
      "?page=" +
      page +
      "&sort_by=" +
      encodeURIComponent(currentSort)
    );
  }

  function fetchSection(url) {
    return fetch(url)
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        return parser.parseFromString(html, "text/html");
      });
  }

  function formatCount(total) {
    return total + (total === 1 ? " product" : " products");
  }

  function reloadCollection(page) {
    if (loading) return;
    loading = true;
    root.classList.add("is-loading");

    fetchSection(buildSectionUrl(page))
      .then(function (doc) {
        var newRoot = doc.querySelector("[data-collection]");
        if (!newRoot) {
          loading = false;
          root.classList.remove("is-loading");
          return;
        }

        var newGrid = newRoot.querySelector("[data-collection-grid]");
        var newPagination = newRoot.querySelector("[data-collection-pagination]");
        var newTotalPages = parseInt(newRoot.getAttribute("data-total-pages"), 10) || 1;
        var newTotalItems = parseInt(newRoot.getAttribute("data-total-items"), 10) || 0;

        if (newGrid && grid) {
          grid.className = newGrid.className;
          grid.innerHTML = newGrid.innerHTML;
          if (newGrid.hasAttribute("hidden")) grid.setAttribute("hidden", "");
          else grid.removeAttribute("hidden");
        }

        if (paginationNav) {
          if (newPagination && !newPagination.hasAttribute("hidden") && newPagination.innerHTML.trim()) {
            paginationNav.innerHTML = newPagination.innerHTML;
            paginationNav.removeAttribute("hidden");
            bindPaginationLinks();
          } else {
            paginationNav.innerHTML = "";
            paginationNav.setAttribute("hidden", "");
          }
        }

        currentPage = page;
        totalPages = newTotalPages;
        totalItems = newTotalItems;

        if (countEl) countEl.textContent = formatCount(totalItems);

        root.setAttribute("data-current-page", String(currentPage));
        root.setAttribute("data-total-pages", String(totalPages));
        root.setAttribute("data-total-items", String(totalItems));
        root.setAttribute("data-current-sort", currentSort);

        if (window.history && window.history.replaceState) {
          window.history.replaceState({}, "", buildPublicUrl(page));
        }

        loading = false;
        root.classList.remove("is-loading");
        root.scrollIntoView({ behavior: "smooth", block: "start" });
      })
      .catch(function () {
        loading = false;
        root.classList.remove("is-loading");
      });
  }

  function bindPaginationLinks() {
    if (!paginationNav) return;
    paginationNav.querySelectorAll("[data-pagination-link]").forEach(function (link) {
      if (link.dataset.paginationBound) return;
      link.dataset.paginationBound = "1";
      link.addEventListener("click", function (event) {
        event.preventDefault();
        var href = link.getAttribute("href") || "";
        var match = href.match(/[?&]page=(\d+)/);
        var page = match ? parseInt(match[1], 10) : 1;
        reloadCollection(page);
      });
    });
  }

  bindPaginationLinks();
})();
